module.exports = __webpack_public_path__ + "static/iphonex-tutoring-6608e3dc31d5030e78c2261120f173f7.png";